import React from 'react';

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', padding: '2rem',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}>
        <div style={{ textAlign: 'center', maxWidth: 420 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#e53e3e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </div>
          <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 600 }}>Что-то пошло не так</h2>
          <p style={{ margin: '0 0 24px', color: '#718096', fontSize: 14, lineHeight: 1.5 }}>
            Произошла непредвиденная ошибка. Попробуйте вернуться назад или перезагрузить страницу.
          </p>
          {this.state.error && (
            <details style={{ marginBottom: 24, textAlign: 'left', fontSize: 12, color: '#a0aec0' }}>
              <summary style={{ cursor: 'pointer', marginBottom: 8 }}>Подробности</summary>
              <pre style={{
                background: '#f7fafc', padding: 12, borderRadius: 8,
                overflow: 'auto', maxHeight: 120, fontSize: 11, whiteSpace: 'pre-wrap',
              }}>
                {this.state.error.message}
              </pre>
            </details>
          )}
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <button
              onClick={this.handleReset}
              style={{
                padding: '8px 20px', borderRadius: 8, border: '1px solid #e2e8f0',
                background: '#fff', cursor: 'pointer', fontSize: 14,
              }}
            >
              Попробовать снова
            </button>
            <button
              onClick={this.handleReload}
              style={{
                padding: '8px 20px', borderRadius: 8, border: 'none',
                background: '#48bb78', color: '#fff', cursor: 'pointer', fontSize: 14,
              }}
            >
              Перезагрузить
            </button>
          </div>
        </div>
      </div>
    );
  }
}
